module.exports = __webpack_public_path__ + "static/media/main-business-01.2c78557.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-business-01.mp4
// module id = ZW3F
// module chunks = 1